import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["name", "iconStyle"];
// @ts-ignore svg import
import COMMERCE_HUB_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/CommerceHub.svg';
// @ts-ignore svg import
import CONTENT_HUB_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/ContentHub.svg';
// @ts-ignore svg import
import DATA_HUB_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/DataHub.svg';
// @ts-ignore svg import
import MARKETING_HUB_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/MarketingHub.svg';
// @ts-ignore svg import
import SALES_HUB_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/SalesHub.svg';
// @ts-ignore svg import
import SERVICE_HUB_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/ServiceHub.svg';
import { Image } from 'foundations-components/transitional/components/Image';
import { filterProps } from 'foundations-components/utils/filterProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductIcon = _ref => {
  let {
      name,
      iconStyle
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const getIconSrc = () => {
    switch (name) {
      case 'MARKETING_PRODUCTS':
        return MARKETING_HUB_ICON;
      case 'SALES_PRODUCTS':
        return SALES_HUB_ICON;
      case 'SERVICE_HUB_PRODUCTS':
        return SERVICE_HUB_ICON;
      case 'CMS_HUB_PRODUCTS':
        return CONTENT_HUB_ICON;
      case 'OPERATIONS_HUB_PRODUCTS':
        return DATA_HUB_ICON;
      case 'COMMERCE_PRODUCTS':
        return COMMERCE_HUB_ICON;
      default:
        return null;
    }
  };
  const icon = getIconSrc();
  const {
    domProps,
    callbackProps
  } = filterProps(rest);
  return /*#__PURE__*/_jsx(Image, Object.assign({
    src: icon,
    alt: `${name} Hub`,
    display: "inline-block"
  }, iconStyle, domProps, callbackProps));
};